.ay{flex-shrink:0;}